import { css } from '@emotion/react';

const reset = css`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    text-decoration: none;
    color: inherit;
  }
`;

export default reset;
